import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
    providedIn: 'root'
})

export class FrontendService {
    constructor(
        private httpService: HttpService,
    ) { }

    loadCms(payload: any) {
        return this.httpService.post('v1/frontend/cms/load', payload);
    }

    aboutUsCms(payload: any) {
        return this.httpService.post('v1/frontend/cms/about-us', payload);
    }

    contactFormSubmit(payload: any) {
        return this.httpService.post('v1/frontend/contact-form/submit', payload);
    }

    newsletterSubmit(payload: any) {
        return this.httpService.post('v1/frontend/newsletter/submit', payload);
    }
}